export const authkey = "auth";
export const currentLang = "currentLang";
export const localizationChannel = "setLocalizationEvent";
import localization from "services/localization";

export const APP_VERSION = "1.0.0";

export const SUBJECTS = [
  {
    value: "Arte e Immagine",
    label: localization.art_and_image || "Art and Image",
  },
  {
    value: "Diritto ed Economia",
    label: localization.law_and_economics || "Law and Economics",
  },
  {
    value: "Economia Aziendale",
    label: localization.business_economics || "Business Economics",
  },
  {
    value: "Educazione Civica",
    label: localization.civic_education || "Civic Education",
  },
  {
    value: "Educazione Fisica",
    label: localization.physical_education || "Physical Education",
  },
  { value: "Filosofia", label: localization.philosophy || "Philosophy" },
  { value: "Fisica", label: localization.physics || "Physics" },
  { value: "Francese", label: localization.french || "French" },
  { value: "Geografia", label: localization.geography || "Geography" },
  { value: "Greco", label: localization.greek || "Greek" },
  { value: "Inglese", label: localization.english || "English" },
  { value: "Italiano", label: localization.italian || "Italian" },
  {
    value: "Laboratori Professionali",
    label: localization.professional_labs || "Professional Labs",
  },
  { value: "Latino", label: localization.latin || "Latin" },
  { value: "Matematica", label: localization.mathematics || "Mathematics" },
  { value: "Musica", label: localization.music || "Music" },
  {
    value: "Religione Cattolica (o alternativa)",
    label:
      localization.catholic_religion_or_alternative ||
      "Catholic Religion or Alternative",
  },
  { value: "Scienze", label: localization.science || "Science" },
  {
    value: "Scienze Umane",
    label: localization.human_science || "Human Science",
  },
  { value: "Storia", label: localization.history || "History" },
  {
    value: "Tecnologia e Informatica",
    label:
      localization.technology_and_computer_science ||
      "Technology and Computer Science",
  },
];

export const CONVERSATION_STATUS_OPTIONS = [
  { value: "allowed", label: localization.allowed || "Allowed" },
  { value: "warning", label: localization.warning || "Warning" },
  { value: "blocked", label: localization.blocked || "Blocked" },
];

export const TYPE_OPTIONS = [
  { value: "teaching", label: localization.teaching || "Teaching" },
  {
    value: "administration",
    label: localization.administration || "Administration",
  },
];

export const LANGUAGE_OPTIONS = [
  { value: "It", label: localization.italian || "Italian" },
  { value: "En", label: localization.english || "English" },
];

export const getTemplateTypes = () => [
  { value: "chat", label: localization.chat || "Chat" },
  { value: "document", label: localization.document || "Document" },
  { value: "image", label: localization.image || "Image" },
  { value: "video", label: localization.video || "Video" },
];

export const TYPE_COLORS = {
  chat: "bg-blue-100 text-blue-700 border-blue-300",
  document: "bg-purple-100 text-purple-700 border-purple-300",
  image: "bg-indigo-100 text-indigo-700 border-indigo-300",
  video: "bg-cyan-100 text-cyan-700 border-cyan-300",
};

export const INPUT_TYPES = [
  { value: "text", label: localization.text_input || "Text Input" },
  { value: "textarea", label: localization.text_area || "Text Area" },
  { value: "date", label: localization.date_picker || "Date Picker" },
  {
    value: "datetime",
    label: localization.date_time_picker || "Date & Time Picker",
  },
  { value: "number", label: localization.number || "Number" },
  { value: "select", label: localization.select_dropdown || "Select Dropdown" },
  {
    value: "file-uploader",
    label: localization.file_uploader || "File Uploader",
  },
  { value: "student-list", label: localization.member_list || "Member List" },
];

export const ALL_TYPES_OPTIONS = [
  { value: "all", label: localization.all || "All" },
  { value: "teaching", label: localization.teaching || "Teaching" },
  {
    value: "administration",
    label: localization.administration || "Administration",
  },
];

export const GRADES_OPTIONS = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
];

export const TEMPLATE_TYPES_OPTIONS = [
  { value: "all", label: localization.all || "All" },
  { value: "student", label: localization.student || "Student" },
  { value: "teaching", label: localization.teaching || "Teaching" },
  {
    value: "administration",
    label: localization.administration || "Administration",
  },
];

export const ROLE_MAP = {
  classroom: {
    assigned: ["teacher"],
    members: ["student"],
  },
  hr: {
    assigned: ["administrative"],
    members: ["administrative"],
  },
  administrative: {
    assigned: ["administrative"],
    members: ["administrative"],
  },
};

export const USER_ROLES = [
  { value: "all", label: localization.all || "All" },
  { value: "student", label: localization.student || "Student" },
  { value: "teacher", label: localization.teacher || "Teacher" },
  {
    value: "administrative",
    label: localization.administration || "Administration",
  },
  { value: "root", label: localization.super_admin || "Super Admin" },
];

export const LLM_MODELS = [
  { value: "gemini-2.5-flash", label: "Gemini 2.5 Flash" },
  { value: "gemini-2.5-flash-lite", label: "Gemini 2.5 Flash Lite" },
  { value: "gemini-2.5-pro", label: "Gemini 2.5 Pro" },
  { value: "gemini-3-flash-preview", label: "Gemini 3.0 Flash Preview" },
  { value: "gemini-3-pro-preview", label: "Gemini 3.0 Pro Preview" },
];

export const getDepartmentTypes = () => [
  // { value: "utilities", label: localization.utilities || "Utilities" },
  { value: "classroom", label: localization.classroom || "Classroom" },
  { value: "hr", label: localization.hr || "HR" },
  {
    value: "administrative",
    label: localization.administration || "Administration",
  },
];

export const ORGANIZATION_TYPES = [
  {
    value: "Scuola dell'infanzia",
    label: localization.kindergarten || "Scuola dell'infanzia",
  },
  {
    value: "Scuola primaria",
    label: localization.elementary_school || "Scuola Primaria",
  },
  {
    value: "Scuola secondaria di primo grado",
    label: localization.middle_school || "Scuola Secondaria di Primo Grado",
  },
  {
    value: "Scuola secondaria di secondo grado",
    label: localization.high_school || "Scuola Secondaria di Secondo Grado",
  },
];

export const ORGANIZATION_SUB_TYPES = [
  {
    value: "Liceo Classico",
    label: localization.liceo_classico || "Liceo Classico",
  },
  {
    value: "Liceo Scientifico",
    label: localization.liceo_scientifico || "Liceo Scientifico",
  },
  {
    value: "Liceo Linguistico",
    label: localization.liceo_linguistico || "Liceo Linguistico",
  },
  {
    value: "Liceo delle Scienze Umane",
    label: localization.liceo_scienze_umane || "Liceo delle Scienze Umane",
  },
  {
    value: "Liceo Artistico",
    label: localization.liceo_artistico || "Liceo Artistico",
  },
  {
    value: "Liceo Musicale e Coreutico",
    label:
      localization.liceo_musicale_coreutico || "Liceo Musicale e Coreutico",
  },
  {
    value: "Istituto Tecnico",
    label: localization.istituto_tecnico || "Istituto Tecnico",
  },
  {
    value: "Istituto Professionale",
    label: localization.istituto_professionale || "Istituto Professionale",
  },
];

// export const TEMPLATE_TYPES = [
//   { value: "discussion", label: "Discussion" },
//   { value: "essay", label: "Essay" },
//   { value: "summary", label: "Summary" },
//   { value: "question_answering", label: "Question Answering" },
//   { value: "translation", label: "Translation" },
//   { value: "lessons_plan", label: "Lessons Plan" },
//   { value: "quiz_generation", label: "Quiz Generation" },
//   { value: "flashcards_generation", label: "Flashcards Generation" },
//   { value: "determina", label: "Determina" },
//   { value: "pei", label: "PEI" },
//   { value: "pdp", label: "PDP" },
//   { value: "iep", label: "IEP" },
//   { value: "ptof", label: "PTOF" },
//   { value: "school_report", label: "School Report" },
// ];
